define(function(require) {
    var $ = require('jquery');

    // this is used for the Quick Links block and the Tool Selector block.
    $('.doctor-finder select, .page-navigation select').change(function () {
        var target = $(this).val();
        var openInNewTab = $('#OpenLinksInNewTab').val();
        if (target) {
            if (openInNewTab === "True") {
                window.open(target, "_blank");
            } else {
                window.location.href = target;
            }
        }
    });

    // for bootstrap select page switchers
    $("select#lookUpToolsOptions").on("changed.bs.select",
        function(e, clickedIndex, newValue, oldValue) {
            // console.log(this.value, clickedIndex, newValue, oldValue);
            var target = $(this).val();
            var openInNewTab = $('#OpenLinksInNewTab').val();
            if (target) {
                if (openInNewTab === "True") {
                    window.open(target, "_blank");
                } else {
                    window.location.href = target;
                }
            }
        });

});
